import { createContext, useContext } from "react";

export type Lang = "pt" | "en";

type Dict = Record<string, { pt: string; en: string }>;

export const STRINGS: Dict = {
  appTitle: { pt: "Automatrix", en: "Automatrix" },
  tagline: {
    pt: "Escolha o melhor horário e confirme em segundos.",
    en: "Pick the best time and confirm in seconds.",
  },
  heroBookA: { pt: "Marque uma ", en: "Book a " },
  heroBookB: { pt: "conversa.", en: "conversation." },
  heroBookSub: {
    pt: "Escolha um horário livre e receba na hora o convite com link de vídeo.",
    en: "Pick an open slot and get an instant invite with a video link.",
  },
  heroAdminA: { pt: "Sua agenda, ", en: "Your calendar, " },
  heroAdminB: { pt: "sob controle.", en: "in control." },
  heroAdminSub: {
    pt: "Conecte sua conta e defina quando pode ser agendado.",
    en: "Connect your account and define when you can be booked.",
  },
  metaWindow: { pt: "Janela", en: "Window" },
  metaTz: { pt: "Fuso", en: "Timezone" },
  metaMeet: { pt: "Vídeo", en: "Video" },
  pickDate: { pt: "Escolha uma data", en: "Pick a date" },
  pickTime: { pt: "Horários disponíveis", en: "Available times" },
  periodMorning: { pt: "Manhã", en: "Morning" },
  periodAfternoon: { pt: "Tarde", en: "Afternoon" },
  periodEvening: { pt: "Noite", en: "Evening" },
  calendarPrevMonth: { pt: "Mês anterior", en: "Previous month" },
  calendarNextMonth: { pt: "Próximo mês", en: "Next month" },
  timezoneLabel: { pt: "Seu fuso horário", en: "Your timezone" },
  timezoneHint: {
    pt: "Detectamos automaticamente — ajuste se estiver viajando.",
    en: "Auto-detected — adjust if you're traveling.",
  },
  timezoneTitle: { pt: "Em qual fuso você está?", en: "What timezone are you in?" },
  timezoneStepHelper: {
    pt: "Assim os horários do calendário aparecem certinhos pra você, sem conta de cabeça.",
    en: "This way the calendar times show up correctly for you, no mental math needed.",
  },
  intakeStepTimezone: { pt: "Seu fuso horário", en: "Your timezone" },
  bookingInTz: { pt: "Horários exibidos em", en: "Times shown in" },
  noSlots: {
    pt: "Nenhum horário disponível neste dia.",
    en: "No available times on this day.",
  },
  loadingSlots: { pt: "Carregando horários…", en: "Loading times…" },
  yourDetails: { pt: "Seus dados", en: "Your details" },
  name: { pt: "Nome", en: "Name" },
  email: { pt: "E-mail", en: "Email" },
  phone: { pt: "Telefone", en: "Phone" },
  notes: { pt: "Observações (opcional)", en: "Notes (optional)" },
  confirmBooking: { pt: "Confirmar agendamento", en: "Confirm booking" },
  booking: { pt: "Agendando…", en: "Booking…" },
  back: { pt: "Voltar", en: "Back" },
  bookedTitle: { pt: "Agendamento confirmado!", en: "Booking confirmed!" },
  bookedWhen: { pt: "Quando", en: "When" },
  meetLink: { pt: "Link da videochamada", en: "Video call link" },
  bookedEmailSent: {
    pt: "Enviamos uma confirmação para o seu e-mail.",
    en: "We sent a confirmation to your email.",
  },
  newBooking: { pt: "Fazer outro agendamento", en: "Make another booking" },
  slotTaken: {
    pt: "Esse horário acabou de ser ocupado. Escolha outro.",
    en: "That time was just taken. Please pick another.",
  },
  genericError: {
    pt: "Algo deu errado. Tente novamente.",
    en: "Something went wrong. Please try again.",
  },
  required: { pt: "Campo obrigatório", en: "Required field" },
  invalidEmail: { pt: "E-mail inválido", en: "Invalid email" },
  // Admin
  adminTitle: { pt: "Painel da Agenda", en: "Scheduling Admin" },
  connectGoogle: { pt: "Conectar conta Google", en: "Connect Google account" },
  connectHint: {
    pt: "Conecte sua conta Google para liberar os agendamentos.",
    en: "Connect your Google account to enable bookings.",
  },
  reconnect: { pt: "Reconectar conta", en: "Reconnect account" },
  settings: { pt: "Regras de disponibilidade", en: "Availability rules" },
  viewLeads: { pt: "Ver leads e reuniões", en: "View leads & bookings" },
  viewSettings: { pt: "Regras de disponibilidade", en: "Availability rules" },
  slotDuration: { pt: "Duração do horário (min)", en: "Slot duration (min)" },
  slotInterval: { pt: "Intervalo entre horários (min)", en: "Interval between slots (min)" },
  daysOfWeek: { pt: "Dias da semana", en: "Days of week" },
  overridesTitle: { pt: "Datas específicas", en: "Specific dates" },
  overridesHint: {
    pt: "Bloqueie um dia inteiro ou defina um horário diferente para uma data específica.",
    en: "Block a whole day or set custom hours for a specific date.",
  },
  addOverride: { pt: "Adicionar data", en: "Add date" },
  removeOverride: { pt: "Remover", en: "Remove" },
  overrideBlocked: { pt: "Bloqueado (indisponível)", en: "Blocked (unavailable)" },
  overrideCustomHours: { pt: "Horário personalizado", en: "Custom hours" },
  noOverrides: { pt: "Nenhuma data personalizada.", en: "No custom dates yet." },
  windowStart: { pt: "Início da janela", en: "Window start" },
  windowEnd: { pt: "Fim da janela", en: "Window end" },
  minNotice: { pt: "Antecedência mínima (min)", en: "Minimum notice (min)" },
  buffer: { pt: "Buffer entre eventos (min)", en: "Buffer between events (min)" },
  save: { pt: "Salvar", en: "Save" },
  saved: { pt: "Salvo!", en: "Saved!" },
  upcoming: { pt: "Próximos eventos", en: "Upcoming events" },
  noEvents: { pt: "Nenhum evento próximo.", en: "No upcoming events." },
  mon: { pt: "Seg", en: "Mon" },
  tue: { pt: "Ter", en: "Tue" },
  wed: { pt: "Qua", en: "Wed" },
  thu: { pt: "Qui", en: "Thu" },
  fri: { pt: "Sex", en: "Fri" },
  sat: { pt: "Sáb", en: "Sat" },
  sun: { pt: "Dom", en: "Sun" },
  // Wizard / Demand Input
  demandTabText: { pt: "Texto", en: "Text" },
  demandTabAudio: { pt: "Áudio", en: "Audio" },
  demandTabFiles: { pt: "Arquivos", en: "Files" },
  demandTextPlaceholder: {
    pt: "Descreva o que você precisa…",
    en: "Describe what you need…",
  },
  demandRecordStart: { pt: "Gravar áudio", en: "Record audio" },
  demandRecordStop: { pt: "Parar gravação", en: "Stop recording" },
  demandTranscriptLabel: { pt: "Transcrição (edite se necessário)", en: "Transcript (edit if needed)" },
  demandTranscriptPlaceholder: {
    pt: "A transcrição aparecerá aqui após a gravação.",
    en: "The transcript will appear here after recording.",
  },
  demandDropHint: { pt: "Arraste arquivos aqui ou clique para escolher", en: "Drag files here or click to choose" },
  demandFileRemove: { pt: "Remover", en: "Remove" },
  wizardNext: { pt: "Próximo", en: "Next" },
  wizardBack: { pt: "Voltar", en: "Back" },
  wizardFinish: { pt: "Enviar", en: "Submit" },
  wizardStepOf: { pt: "Passo {n} de {total}", en: "Step {n} of {total}" },
  // Intake
  intakeEyebrow: { pt: "Vamos te conhecer", en: "Let's get to know you" },
  intakeStepName: { pt: "Qual é o seu nome?", en: "What's your name?" },
  intakeStepNameHelper: {
    pt: "Só pra saber como te chamar — nada de formulário burocrático aqui.",
    en: "Just so we know what to call you — no bureaucratic forms here.",
  },
  intakeStepContact: { pt: "Como podemos te contatar?", en: "How can we reach you?" },
  intakeStepContactHelper: {
    pt: "Seu e-mail e senha criam sua conta — é por eles que você acompanha sua demanda depois.",
    en: "Your email and password create your account — you'll use them to track your demand later.",
  },
  intakeStepSocial: { pt: "Redes sociais (opcional)", en: "Social links (optional)" },
  intakeStepSocialHelper: {
    pt: "Nos ajuda a entender seu negócio e seu público antes da conversa.",
    en: "Helps us understand your business and audience before the call.",
  },
  intakeStepEmployees: { pt: "Quantos funcionários vocês têm?", en: "How many employees do you have?" },
  intakeStepEmployeesHelper: {
    pt: "O porte do time muda a complexidade da solução que faz sentido pra vocês.",
    en: "Team size changes what level of solution makes sense for you.",
  },
  intakeStepHired: {
    pt: "Você já contratou serviços de software/automação/IA antes?",
    en: "Have you hired software/automation/AI services before?",
  },
  intakeStepHiredHelper: {
    pt: "Saber sua experiência anterior evita repetir o que já não funcionou.",
    en: "Knowing your past experience helps us avoid repeating what didn't work.",
  },
  intakeStepTools: { pt: "Quais ferramentas de IA você mais usa?", en: "Which AI tools do you use most?" },
  intakeStepToolsHelper: {
    pt: "Assim conseguimos integrar com o que seu time já usa no dia a dia.",
    en: "This lets us integrate with what your team already uses day to day.",
  },
  intakeStepDemand: { pt: "Descreva sua demanda", en: "Describe your demand" },
  intakeStepDemandHelper: {
    pt: "Texto, áudio ou arquivo — escolha o jeito mais fácil de explicar o que você precisa.",
    en: "Text, audio, or file — pick whichever is easiest to explain what you need.",
  },
  intakeStepOther: { pt: "Mais alguma coisa relevante?", en: "Anything else relevant?" },
  intakeStepOtherHelper: {
    pt: "Campo livre — prazos, orçamento, restrições, o que quiser adicionar.",
    en: "Free field — deadlines, budget, constraints, anything you'd like to add.",
  },
  addSocialLink: { pt: "Adicionar rede social", en: "Add social link" },
  yes: { pt: "Sim", en: "Yes" },
  no: { pt: "Não", en: "No" },
  hiredWhatPlaceholder: { pt: "O que foi contratado?", en: "What was hired?" },
  otherNotesPlaceholder: { pt: "Campo livre…", en: "Free text…" },
  intakeDone: { pt: "Obrigado! Preparando sua conta…", en: "Thanks! Setting up your account…" },
  passwordHint: { pt: "Mínimo de 6 caracteres", en: "Minimum 6 characters" },
  intakeStepBookTime: { pt: "Escolha um horário", en: "Pick a time" },
  alreadyBooked: {
    pt: "Você já tem uma reunião agendada. Cancele-a antes de marcar outra.",
    en: "You already have a meeting scheduled. Cancel it before booking another.",
  },
  bookingErrorGeneric: {
    pt: "Não foi possível concluir. Tente novamente.",
    en: "Couldn't complete this. Please try again.",
  },
  loginError: { pt: "E-mail ou senha inválidos.", en: "Invalid email or password." },
  emailAlreadyRegistered: {
    pt: "Este e-mail já tem uma conta com outra senha.",
    en: "This email already has an account with a different password.",
  },
  // Login / Signup / Dashboard / New Request
  loginTitle: { pt: "Entrar", en: "Log in" },
  loginWithGoogle: { pt: "Continuar com Google", en: "Continue with Google" },
  orDivider: { pt: "ou", en: "or" },
  password: { pt: "Senha", en: "Password" },
  loginSubmit: { pt: "Entrar", en: "Log in" },
  noAccount: { pt: "Ainda não tem conta?", en: "Don't have an account?" },
  signupLink: { pt: "Criar conta", en: "Sign up" },
  signupTitle: { pt: "Criar conta", en: "Create account" },
  signupSubmit: { pt: "Criar conta", en: "Create account" },
  haveAccount: { pt: "Já tem conta?", en: "Already have an account?" },
  loginLink: { pt: "Entrar", en: "Log in" },
  dashboardEyebrow: { pt: "Sua conta", en: "Your account" },
  latestDemand: { pt: "Sua última demanda", en: "Your latest demand" },
  nextBooking: { pt: "Próxima reunião marcada", en: "Next booked call" },
  noNextBooking: { pt: "Nenhuma reunião marcada.", en: "No call booked yet." },
  bookNewTime: { pt: "Marcar novo horário", en: "Book a new time" },
  newDemandCta: { pt: "Enviar nova demanda", en: "Submit a new demand" },
  pastBookings: { pt: "Agendamentos anteriores", en: "Past bookings" },
  statusReceived: { pt: "Recebida", en: "Received" },
  statusInReview: { pt: "Em análise", en: "In review" },
  statusScheduled: { pt: "Agendada", en: "Scheduled" },
  logout: { pt: "Sair", en: "Log out" },
  newRequestTitle: { pt: "Nova demanda", en: "New demand" },
  submitRequest: { pt: "Enviar", en: "Submit" },
  requestSent: { pt: "Demanda enviada!", en: "Demand submitted!" },
  // Admin — Leads / Client Detail
  leadsTitle: { pt: "Leads recebidos", en: "Leads" },
  leadsSearchPlaceholder: { pt: "Buscar por nome ou email…", en: "Search by name or email…" },
  leadsColName: { pt: "Nome", en: "Name" },
  leadsColEmployees: { pt: "Funcionários", en: "Employees" },
  leadsColDate: { pt: "Data", en: "Date" },
  leadsColStatus: { pt: "Status", en: "Status" },
  clientDetailBack: { pt: "Voltar aos leads", en: "Back to leads" },
  clientAnswersTitle: { pt: "Respostas do questionário", en: "Questionnaire answers" },
  clientDemandTitle: { pt: "Demanda", en: "Demand" },
  clientBookingsTitle: { pt: "Agendamentos", en: "Bookings" },
  clientNoBookings: { pt: "Nenhum agendamento ainda.", en: "No bookings yet." },
};

export const LangContext = createContext<{
  lang: Lang;
  setLang: (l: Lang) => void;
}>({ lang: "en", setLang: () => {} });

export function useT() {
  const { lang, setLang } = useContext(LangContext);
  const t = (key: keyof typeof STRINGS): string => {
    const entry = STRINGS[key];
    if (!entry) return String(key);
    // English is the primary language of the application
    return entry.en || entry.pt || String(key);
  };
  return { t, lang, setLang };
}

export function loadLang(): Lang {
  return "en";
}

export function saveLang(_l: Lang) {
  // English only
}
